import React from 'react';
import getProductType from './ProductType';

function Logo(props) {
  const productType = getProductType();

  return (
    <img
      alt="Logo"
      src={
        productType === 'Signzy' ? '/static/signzy.png' : '/static/precisa.png'
      }
      {...props}
    />
  );
}

export default Logo;
